import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { AssetChubbBookingBanner } from '@asset-chubb-booking-banner';

export function isActiveFreeChubbBanner(
  bookingType: TravelBookingType, isAnInternationalTrip: boolean, isUserPrime: boolean
): boolean {
  const criteria = AssetChubbBookingBanner.ENABLED_FREE_ASSISTANCE;
  const isValidGeneral = !!criteria.TYPES?.includes(bookingType);
  if (isValidGeneral) {
    const isValidByPrimeCriteria = criteria.ONLY_PRIME_USER;
    if (!criteria.IS_INTERNATIONAL_TRIP && isAnInternationalTrip) return false;
    if (criteria.IS_NATIONAL_TRIP && isAnInternationalTrip) return false;
    if (isValidByPrimeCriteria && !isUserPrime) return false;
    return true;
  } else {
    return false;
  }
}

export function isActiveByPrimeCriteriaFree(isUserPrime: boolean): boolean {
  const isValidByPrimeCriteria = AssetChubbBookingBanner.ENABLED_FREE_ASSISTANCE.ONLY_PRIME_USER;
  return isValidByPrimeCriteria && isUserPrime;
}
